import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay } from '@fortawesome/free-regular-svg-icons';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, Pagination, Stack, DialogActions } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { deleteGamePost, getAllPostCounts, getFetchGamePostFileThumbnail, getVideos, markGamePostFav } from '../../../redux/network/videoApi';
import { useLocation, useNavigate } from 'react-router-dom';
import FullScreenDialog from '../../VideoPlayerModel/VideoPlayerModel';
import { GET_POST_CONTENT } from '../../../config/endpoints';
import thumbnail from './thumbnail.jpg';
import { deleteVideoPost, error_GetFetchVideoContent, isStarted_GetFetchVideoContent, success_GetFetchVideoContent, toggleFavVideoPost, toggleVideoSortDropdown } from '../../../redux/reducers/videoSlice';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { setAlertMessage, setAlertType } from '../../../redux/reducers/alertSlice';
import { buyReviewCredits, getUserProfile } from '../../../redux/network/userApi';
import UploadVideoModel from '../../UploadVideoModel/UploadVideoModel';
import { setVideoUploadDialogOpen } from '../../../redux/reducers/loginSlice';
import CustomDropdown from '../../CustomeDropdown/CustomDropdown';
import CoachFeedback from '../../CoachFlow/CoachFeedback';
import CloseIcon from '@mui/icons-material/Close';
import { addStandAloneVideoFunction } from '../../../redux/network/standAloneApi';
import { } from "@mui/material";
import SearchVideos from "../../SearchBoxes/SearchVideos";
import { VIDEO_SEARCH_API_LIMIT, SEARCH_BOX, COACH_NOT_ASSIGNED } from "../../../constant"
import SearchUploadedVideoPagination from '../../Pagination/SearchUploadedVideoPagination/SearchUploadedVideoPagination';
import CoachName from '../CoachName/CoachName';
import { usePagination } from '../../../hooks/usePagination';
import ReactGA from 'react-ga4';
import TagHelper from '../../../helpers/PostHelpers/TagHelper';

// VideoJS deprecation warnings are suppressed globally in utils/videojsWarnings.js
const dropdownOptions = [
    { value: 'all', label: 'All Videos' },
    { value: 'created', label: 'Uploaded' },
    { value: 'reviewRequested', label: 'Requested' },
    { value: 'reviewed', label: 'Completed' },
    { value: 'favourites', label: 'Favourites' },
];

/*const filterOptions = [
    { value: 'bookmarked', label: 'Bookmarked' },
    { value: 'unbookmarked', label: 'Unbookmarked' },
];*/
const extractTitle = (videoPath) => {
    if (!videoPath) return "Unknown Title";
    const filename = videoPath.split('/').pop().replace(/\.[^/.]+$/, "");
    return filename;
};

const truncateTitle = (title, maxWords = 6) => {
    if (!title) return "";
    const words = title.split(" ");
    return words.length > maxWords ? words.slice(0, maxWords).join(" ") + " ..." : title;
};


const dataFormatter = (dateString) => {
    const inputDate = new Date(dateString);

    const monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
    ];

    const day = inputDate.getDate();
    const monthIndex = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const hours = inputDate.getHours();
    const minutes = inputDate.getMinutes();

    return `${day} ${monthNames[monthIndex]} ${year} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

const getTimeRange = (range) => {
    const now = new Date();
    let start, end;
    switch (range) {
        case 'lastOneWeek':
            start = new Date(now.setDate(now.getDate() - 7));
            end = new Date();
            break;
        case 'lastMonth':
            start = new Date(now.setMonth(now.getMonth() - 1));
            end = new Date();
            break;
        case 'last3Months':
            start = new Date(now.setMonth(now.getMonth() - 3));
            end = new Date();
            break;
        default:
            start = null;
            end = null;
    }
    return { start: start?.getTime(), end: end?.getTime() };
}

const GameVideos = () => {
    const location = useLocation();
    const { pathname, state } = location;
    const [newVideoDataFromUpload, setNewVideoDataFromUpload] = useState(state?.newVideoData || null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const jwtToken = localStorage.getItem("BQS_TOKEN");
    const userId = localStorage.getItem("BQS__ID");
    let { isStarted, isError, error, data, totalNumberOfRecords } = useSelector(state => state.video.video);
    let totalNumberOfPages = Math.ceil(totalNumberOfRecords / VIDEO_SEARCH_API_LIMIT);

    console.log("standalone video---->", data)

    const { resetToDefault } = useSelector(state => state.video.videoSortDropdown);
    const postCountData = useSelector(state => state.video.videosCount);
    const userData = useSelector((state) => state.user.profile);
    const isUploadDialogOpen = useSelector((state) => state.login.isVideoUploadDialogOpen);

    // Custom pagination hook
    const {
        currentPage,
        totalPages,
        totalRecords,
        searchTerm,
        sortOption,
        goToPage,
        updateSearchTerm,
        updateSortOption
    } = usePagination('gameVideos');

    // Local state
    const [coachName, setCoachName] = useState(null);
    const [coachNameKey, setCoachNameKey] = useState(0);
    const [animatedFavs, setAnimatedFavs] = useState({});
    const [deletedPostId, setDeletedPostId] = useState(null);
    const [open, setOpen] = useState(false);
    const [videoThumbnails, setVideoThumbnails] = useState({});
    const [thumbnailLoading, setThumbnailLoading] = useState({});
    const [limit] = useState(VIDEO_SEARCH_API_LIMIT);

    const [updateTrigger, setUpdateTrigger] = useState(false);
    const [avoidUpdateTrigger, setAvoidUpdateTrigger] = useState(false);
    const [newlyUploadedVideoId, setNewlyUploadedVideoId] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const env = process.env.REACT_APP_ENV;
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedPost, setSelectedPost] = useState(null);
    const searchTermKey = "searchText_GameVideos";
    const [preSearchPaginationState, setPreSearchPaginationState] = useState(null);
    const [paginationKey, setPaginationKey] = useState(0);

    // Debug tracking
    const prevApiPayload = useRef(null);
    const thumbnailsLoadedRef = useRef(false);
    const prevUploadDialogOpenRef = useRef(false);

    // Derived state
    const remainingReview = userData?.value?.profileData?.membershipProfile?.remainingReviews || 0;

    useEffect(() => {
        updateSortOption(dropdownOptions[0].value);
    }, [resetToDefault])

    // GA: page view for Game Videos
    useEffect(() => {
        try {
            ReactGA.send({ hitType: 'pageview', page: pathname, title: 'Game Videos' });
        } catch { }
    }, [pathname]);

    // Load search term from localStorage on component mount
    useEffect(() => {
        const savedSearchTerm = localStorage.getItem(searchTermKey);
        if (savedSearchTerm) {
            updateSearchTerm(savedSearchTerm);
        }
    }, []);

    useEffect(() => {

        setCoachName(userData?.value?.roleAssociation?.associates[0]?.profileData?.name ?? COACH_NOT_ASSIGNED);

        setCoachNameKey((prev) => { return prev + 1 });
    }, [userData])

    useEffect(() => {
        switch (sortOption) {
            case 'oldToNew':
                goToPage(1);
                break;
            case 'newToOld':
                goToPage(1);
                break;
            case 'created':
                goToPage(1);
                break;
            case 'reviewRequested':
                goToPage(1);
                break;
            case 'reviewed':
                goToPage(1);
                break;
            case 'favourites':
                goToPage(1);
                break;
            default:
        }
    }, [sortOption]);

    // useEffect(() => {
    //     if (jwtToken) {
    //         dispatch(getUserProfile(jwtToken))
    //     }
    // }, [jwtToken, dispatch])


    const handleChange = (event, value) => {
        goToPage(value);
        window.scrollTo(0, 0);
    };

    // Function to construct the conditions - memoized to prevent unnecessary recalculations
    const constructConditions = useMemo(() => {
        const { start, end } = getTimeRange(sortOption);
        let conditions = { "poster": userId };

        // Add time range condition if applicable
        if (start && end) {
            conditions.createdAt = { start, end };
        }
        if (sortOption === "created") {
            conditions.state = ["created"]
        } else if (sortOption === "reviewRequested") {
            conditions.state = ["review_requested"]
        } else if (sortOption === "reviewed") {
            conditions.state = ["reviewed"]
        } else if (sortOption === "favourites") {
            conditions.fav = true;
        } else {
            conditions.state = ["created", "review_requested", "reviewed"]
        }
        conditions.searchTerm = searchTerm;

        return conditions;
    }, [userId, sortOption, searchTerm]);

    // Memoize API payload to prevent unnecessary API calls
    const apiPayload = useMemo(() => {
        if (!jwtToken || !userId || env === "standalone") {
            return null;
        }

        return {
            "condition": constructConditions,
            "sort": {
                "updatedAt": -1
            },
            "skip": currentPage - 1,
            "limit": VIDEO_SEARCH_API_LIMIT,
        };
    }, [jwtToken, userId, constructConditions, currentPage, env]);

    //All Posts Count
    useEffect(() => {
        if (jwtToken && userId && !avoidUpdateTrigger && env !== "standalone") {
            console.log("📡 GameVideos API Call - Count:", {
                currentPage,
                sortOption,
                searchTerm,
                skip: currentPage - 1  // Use page - 1 for skip
            });

            dispatch(getAllPostCounts(jwtToken, {
                "condition": constructConditions,
            }));
        }
    }, [jwtToken, userId, currentPage, sortOption, updateTrigger, avoidUpdateTrigger, searchTerm, constructConditions]);

    //All Posts Details - only when apiPayload changes
    useEffect(() => {
        if (apiPayload) {
            console.log("📡 GameVideos API Call - Videos:", apiPayload);
            dispatch(getVideos(jwtToken, apiPayload));
        }
    }, [apiPayload, jwtToken, dispatch]);

    // Refresh list when upload dialog closes (after an upload completes)
    useEffect(() => {
        const wasOpen = prevUploadDialogOpenRef.current;
        if (wasOpen && !isUploadDialogOpen && jwtToken && userId) {
            goToPage(1);
            if (localStorage.getItem('uploadSuccess') === 'true') {
                const newId = localStorage.getItem('newlyUploadedVideoId');
                console.log("🔥 [GameVideos] Found uploadSuccess=true, newId=", newId);
                if (newId) {
                    setNewlyUploadedVideoId(newId);
                }
                localStorage.removeItem('uploadSuccess');
                localStorage.removeItem('newlyUploadedVideoId');
            }
            const refreshedPayload = {
                condition: constructConditions,
                sort: {
                    updatedAt: -1,
                },
                skip: 0,
                limit: VIDEO_SEARCH_API_LIMIT,
            };
            dispatch(getAllPostCounts(jwtToken, { condition: constructConditions }));
            dispatch(getVideos(jwtToken, refreshedPayload));
        }
        prevUploadDialogOpenRef.current = isUploadDialogOpen;
    }, [isUploadDialogOpen, jwtToken, userId, constructConditions, dispatch, goToPage]);

    useEffect(() => {
        if (!newVideoDataFromUpload) {
            return;
        }

        if (typeof window !== 'undefined') {
            TagHelper.persistTags(
                newVideoDataFromUpload.postId,
                newVideoDataFromUpload.key,
                newVideoDataFromUpload.tags || []
            );
        }

        if (jwtToken && userId) {
            goToPage(1);
            const refreshedPayload = {
                condition: constructConditions,
                sort: {
                    updatedAt: -1,
                },
                skip: 0,
                limit: VIDEO_SEARCH_API_LIMIT,
            };
            dispatch(getAllPostCounts(jwtToken, { condition: constructConditions }));
            dispatch(getVideos(jwtToken, refreshedPayload));
        }

        if (location.state?.newVideoData) {
            const nextState = { ...location.state };
            delete nextState.newVideoData;
            navigate(location.pathname, { replace: true, state: nextState });
        }

        setNewVideoDataFromUpload(null);
    }, [newVideoDataFromUpload, jwtToken, userId, constructConditions, dispatch, goToPage, location, navigate]);

    // Update pagination state when video data changes - optimized
    useEffect(() => {
        if (totalNumberOfRecords !== undefined) {
            const totalRecords = totalNumberOfRecords;
            const totalPages = Math.ceil(totalRecords / VIDEO_SEARCH_API_LIMIT);

            console.log('🔄 GameVideos updating pagination:', {
                totalRecords,
                totalPages,
                currentPage,
                searchTerm,
                sortOption,
                component: 'gameVideos'
            });

            // Update Redux state directly without using the hook function
            dispatch({
                type: 'pagination/updatePaginationFromResponse',
                payload: {
                    totalRecords,
                    currentPage,
                    searchTerm,
                    sortOption,
                    component: 'gameVideos'
                }
            });
        }
    }, [totalNumberOfRecords, currentPage, searchTerm, sortOption, dispatch]);

    // Scroll to top when page changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage]);

    // Load thumbnails - optimized to prevent infinite loops
    useEffect(() => {
        if (data?.length > 0 && jwtToken && env !== "standalone") {
            // Check if we've already loaded thumbnails for this data
            const dataHash = JSON.stringify(data.map(v => v._id));
            if (thumbnailsLoadedRef.current === dataHash) {
                return;
            }

            const loadThumbnails = async () => {
                // Only load thumbnails for videos that don't already have them
                const videosNeedingThumbnails = data.filter(video => !videoThumbnails[video._id]);

                if (videosNeedingThumbnails.length === 0) {
                    thumbnailsLoadedRef.current = dataHash;
                    return;
                }

                const loadingStates = {};
                const newThumbnails = { ...videoThumbnails };

                // Set loading states for videos that need thumbnails
                videosNeedingThumbnails.forEach(video => {
                    loadingStates[video._id] = true;
                });
                setThumbnailLoading(prev => ({ ...prev, ...loadingStates }));

                // Fetch thumbnails in parallel
                const thumbnailPromises = videosNeedingThumbnails.map(async (video) => {
                    try {
                        const thumbnailUrl = await getFetchGamePostFileThumbnail(
                            jwtToken,
                            video._id,
                            video.game[0]?.tnPath
                        );
                        return { id: video._id, url: thumbnailUrl };
                    } catch (error) {
                        return { id: video._id, url: null };
                    }
                });

                const results = await Promise.all(thumbnailPromises);

                // Update thumbnails
                results.forEach(({ id, url }) => {
                    if (url) {
                        newThumbnails[id] = url;
                    }
                });

                setVideoThumbnails(newThumbnails);

                // Mark as loaded for this data
                thumbnailsLoadedRef.current = dataHash;

                // Clear loading states
                const clearLoadingStates = {};
                Object.keys(loadingStates).forEach(id => {
                    clearLoadingStates[id] = false;
                });
                setThumbnailLoading(prev => ({ ...prev, ...clearLoadingStates }));
            };

            loadThumbnails();
        }
    }, [data, jwtToken, env]); // Removed videoThumbnails from dependencies to prevent infinite loop

    // Filter videos for standalone mode - memoized to prevent unnecessary recalculations
    const filteredVideos = useMemo(() => {
        return env === "standalone"
            ? data?.filter(video => video.state === "reviewed") || []
            : data || [];
    }, [env, data]);

    const hydratedVideos = useMemo(() => {
        return (filteredVideos || []).map((video) => {
            const persisted = TagHelper.getPersistedTags(
                video?._id,
                video?.game?.[0]?.path
            );
            const mergedTags = TagHelper.mergeTagLists(persisted, video?.tags || []);
            if (!mergedTags.length) {
                return video;
            }
            return {
                ...video,
                tags: mergedTags,
            };
        });
    }, [filteredVideos]);


    async function handlePlayClick(video,) {
        if (newlyUploadedVideoId === video._id) {
            setNewlyUploadedVideoId(null);
        }
        const postId = video._id
        const videoLinkInObjectStore = video.game[0].path;
        console.log("videoLinkInObjectStore--------------", videoLinkInObjectStore);
        localStorage.setItem("videoLinkInObjectStore", videoLinkInObjectStore);
        localStorage.setItem("reviewPostId", postId);
        localStorage.setItem(`prevPath_${postId}`, JSON.stringify(pathname));

        const persistedTags = TagHelper.getPersistedTags(postId, video?.game?.[0]?.path);
        const apiTags = Array.isArray(video.tags) ? video.tags : [];
        const effectiveVideoTags = TagHelper.mergeTagLists(persistedTags, apiTags);
        const videoWithTags = {
            ...video,
            tags: effectiveVideoTags,
        };

        setSelectedVideo(videoWithTags)
        localStorage.setItem(`${postId}_reviewPost`, JSON.stringify(videoWithTags));
        localStorage.setItem("prevPath", JSON.stringify(pathname));

        // GA: video card click
        try {
            ReactGA.event({ category: 'GamePost', action: 'video_card_click', label: video.state || 'unknown' });
        } catch { }


        TagHelper.persistTags(postId, video?.game?.[0]?.path, effectiveVideoTags);

        if (video.state === "reviewed") {

            console.log("Player Portal Video:", video);
            navigate(`feedback/${postId}`, { state: { videoTags: effectiveVideoTags, } })
        } else {
            // if (data.length < videocoutn)
            // {
            console.log("tags", video.tags);
            navigate(`request/${postId}`, { state: { videoTags: effectiveVideoTags } })
            //}
            // else {

            //     const reviewedVideoData =  dispatch(getVideos(jwtToken, {
            //         "condition": {
            //             "poster": userId,
            //             "state" : 'reviewed'
            //         },
            //         "sort": {
            //             "updatedAt": -1
            //         },
            //         "skip": skip,
            //     }));

            //     console.log("reviewed video data is ", reviewedVideoData);

            //     alert("You have reached max number of review requests under your subscription");
            // }

        }


        //stand alone code 
        if (env === "standalone") {
            return null;
        }

        // //const url = `${GET_POST_CONTENT}?postId=${postId}&type=game`;
        const url = localStorage.getItem("videoLinkInObjectStore");

        dispatch(isStarted_GetFetchVideoContent());



        try {
            console.log("length is ", data.length);
            const response = await fetch(url, {
                method: "GET" //,
                // headers: {
                //     'Authorization': `Bearer ${jwtToken}`,
                // },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch video');

            } else {
                console.log(response)
            }

            const reader = response.body.getReader();
            const stream = new ReadableStream({
                start(controller) {
                    return pump();
                    function pump() {
                        return reader.read().then(({ done, value }) => {
                            if (done) {
                                controller.close();
                                return;
                            }
                            controller.enqueue(value);
                            return pump();
                        });
                    }
                }
            });
            const responseBlob = await new Response(stream).blob();
            const file = new File([responseBlob], 'video.mp4', { type: 'video/mp4' });
            const fr = new FileReader();
            fr.readAsDataURL(file);
            fr.addEventListener("load", () => {
                const res = fr.result;
                dispatch(success_GetFetchVideoContent(res));
            });
        } catch (error) {
            dispatch(error_GetFetchVideoContent(error.message || "Error while fetching video"));
            console.error('Error fetching video:', error);
        }
    }

    function RenderNoVideosView() {
        return (
            <div className="flex flex-col items-center justify-center py-20 px-4">
                <div className="text-center max-w-md">
                    <div className="mb-6 inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-emerald-100 to-teal-100">
                        <svg className="w-12 h-12 text-[#247E45]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                    </div>
                    <h6 className="text-xl font-semibold text-slate-700 mb-2">No Videos Yet</h6>
                    <p className="text-slate-500">Once uploaded your gameplay video will appear here</p>
                </div>
            </div>
        );
    }

    function RenderNoVideosWithSearchCondition({ sortOption }) {
        let searchKey;
        if (sortOption === "created") {
            searchKey = "Uploaded";
        } else if (sortOption === "reviewRequested") {
            searchKey = "Requested";
        } else if (sortOption === "reviewed") {
            searchKey = "Completed";
        } else if (sortOption === "favourites") {
            searchKey = "Favourites";
        }
        // Remove filterKey logic since filter is gone
        return (
            <div className="flex flex-col items-center justify-center py-20 px-4">
                <div className="text-center max-w-md">
                    <div className="mb-6 inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-amber-100 to-orange-100">
                        <svg className="w-12 h-12 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>
                    <h5 className="text-xl font-semibold text-slate-700 mb-2">No videos found</h5>
                    <p className="text-slate-500">No videos found with sort: {searchKey || "Default"}</p>
                </div>
            </div>
        );
    }

    async function handleClickFav(postData) {
        if (env === "standalone") {
            return null;
        }

        const postId = postData._id;
        const favToggle = !postData.fav;
        // GA: toggle favourite
        try {
            ReactGA.event({ category: 'GamePost', action: 'toggle_favourite', label: favToggle ? 'set' : 'unset' });
        } catch { }
        const res = await markGamePostFav(jwtToken, postId, favToggle);

        if (res && res.code === 200) {
            setAnimatedFavs(prev => ({ ...prev, [postId]: true }));
            dispatch(toggleFavVideoPost(postId));

            setTimeout(() => {
                if (hydratedVideos.length === 0) {
                    dispatch(toggleVideoSortDropdown())
                }
                setAnimatedFavs(prev => ({ ...prev, [postId]: false }));
            }, 300);
        } else {
            dispatch(setAlertMessage(res.message || "Something went wrong"));
            dispatch(setAlertType("error"));
        }
    }



    const handleClickDel = (postData) => {
        setSelectedPost(postData);
        setOpenDeleteDialog(true);
    };

    const confirmDelete = async () => {
        if (!selectedPost) return;

        setOpenDeleteDialog(false);

        if (env === "standalone") {
            return null;
        }

        const res = await deleteGamePost(jwtToken, selectedPost._id);
        setAvoidUpdateTrigger(true);

        if (res && res.code === 200) {
            try { ReactGA.event({ category: 'GamePost', action: 'delete_video_success' }); } catch { }
            setTimeout(() => {
                setAvoidUpdateTrigger(false);
            }, 1000);

            setDeletedPostId(selectedPost._id);
            setTimeout(() => {
                dispatch(deleteVideoPost(selectedPost._id));
                setDeletedPostId(null);

                // If we're on a page with only one video and it's not the first page, go to previous page
                if (hydratedVideos.length === 1 && currentPage > 1) {
                    setAvoidUpdateTrigger(false);
                    goToPage(currentPage - 1);
                }

                setUpdateTrigger(prev => !prev);
            }, 800);
        } else {
            dispatch(setAlertMessage(res.message || "Something went wrong"));
            dispatch(setAlertType("error"));
        }
    };

    const handleSortChange = (newSortOption) => {
        if (dropdownOptions.some(option => option.value === newSortOption)) {
            try { ReactGA.event({ category: 'GamePost', action: 'sort_change', label: newSortOption }); } catch { }
            updateSortOption(newSortOption);
            goToPage(1);
            setUpdateTrigger(prev => !prev);
        }
    };

    // GA-wrapped search change handler
    const handleSearchChange = (text) => {
        try { ReactGA.event({ category: 'GamePost', action: 'search_change', label: text ? 'non_empty' : 'empty' }); } catch { }
        updateSearchTerm(text);
    };

    // GA-wrapped pagination change handler
    const handlePageChange = (page) => {
        try { ReactGA.event({ category: 'GamePost', action: 'page_change', label: String(page) }); } catch { }
        goToPage(page);
        window.scrollTo(0, 0);
    };

    // Remove handleFilterChange entirely since filter is gone

    async function handleClickBuyCredit() {
        const res = await buyReviewCredits(jwtToken);

        if (res && res.code === 200) {
            dispatch(getUserProfile(jwtToken));
            dispatch(setAlertMessage(res.message || "Credit purchased successfully"));
            dispatch(setAlertType("success"));
            try { ReactGA.event({ category: 'GamePost', action: 'buy_credit', label: 'success' }); } catch { }
        } else {
            dispatch(setAlertMessage(res.message || "Something went wrong"));
            dispatch(setAlertType("error"));
            try { ReactGA.event({ category: 'GamePost', action: 'buy_credit', label: 'error' }); } catch { }
        }
    }

    const handleClickUploadVideo = () => {
        // Disable body scroll
        document.body.classList.remove("modal-open");


        if (env === "standalone") {
            dispatch(addStandAloneVideoFunction());
        } else {
            dispatch(setVideoUploadDialogOpen(true));
        }
        try { ReactGA.event({ category: 'GamePost', action: 'upload_video_click' }); } catch { }
    };


    function handleClickViewReport(postData) {
        localStorage.setItem("reviewPostData", JSON.stringify(postData));
        navigate("/game-feedback/coach-feedback")
        try { ReactGA.event({ category: 'GamePost', action: 'view_report_click' }); } catch { }
    }

    const closeModal = () => {
        setSelectedVideo(null);
        setIsModalOpen(false);
    };


    const [standloan, setStandData] = useState([]);

    useEffect(() => {
        fetch('/Video.json') // Use the relative path if the JSON is in the public folder
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(() => setStandData(standloan))
            .catch((error) => console.error('Error fetching the JSON:', error));
    }, []);

    const videocoutn = typeof postCountData?.data === "number" ? postCountData.data : postCountData.data.count;

    // Debug pagination state
    console.log("🎮 GameVideos Component State:", {
        currentPage,
        totalPages,
        totalRecords,
        searchTerm,
        sortOption,
        dataLength: hydratedVideos?.length || 0,
        postCountData: postCountData?.data,
        totalNumberOfPages,
        totalNumberOfRecords,
        videocoutn
    });

    // Remove the old setSearchText function since we're using local state pagination now

    // Scroll to top when page changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage]);

    // Add debug functions for testing
    useEffect(() => {
        // Add function to test GameVideos pagination
        window.testGameVideosPagination = () => {
            console.log("🧪 Testing GameVideos Pagination (usePagination hook-based):");
            console.log(`📊 Current state:`, {
                currentPage,
                totalPages,
                totalRecords,
                searchTerm,
                sortOption,
                dataLength: hydratedVideos?.length || 0,
                postCountData: postCountData?.data,
                totalNumberOfPages,
                totalNumberOfRecords
            });

            console.log(`🎯 Navigation state:`, {
                canGoPrevious: currentPage > 1,
                canGoNext: currentPage < totalPages,
                isFirstPage: currentPage === 1,
                isLastPage: currentPage === totalPages
            });

            console.log(`📄 Pagination calculation:`, {
                totalRecords,
                VIDEO_SEARCH_API_LIMIT,
                calculatedTotalPages: Math.ceil(totalRecords / VIDEO_SEARCH_API_LIMIT),
                currentSkip: currentPage - 1  // Use page - 1 for skip
            });
        };

        // Add function to manually test navigation
        window.testGameVideosNavigation = (direction) => {
            console.log(`🧪 Testing ${direction} navigation...`);
            if (direction === 'next') {
                goToPage(currentPage + 1);
            } else if (direction === 'previous') {
                goToPage(currentPage - 1);
            }
        };

        // Add function to test search
        window.testGameVideosSearch = (searchText) => {
            console.log(`🧪 Testing search with: "${searchText}"`);
            updateSearchTerm(searchText);
        };

        // Add function to test sort
        window.testGameVideosSort = (sortValue) => {
            console.log(`🧪 Testing sort with: "${sortValue}"`);
            updateSortOption(sortValue);
        };
    }, [currentPage, totalPages, totalRecords, searchTerm, sortOption, data, postCountData, goToPage, updateSearchTerm, updateSortOption]);


    return (
        <>
            {/* Main Container with Gradient Background */}
            <div className="relative min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50">

                {/* Animated Background Pattern */}
                <div className="absolute inset-0 opacity-30 pointer-events-none">
                    <div className="absolute top-0 -left-4 w-72 h-72 bg-emerald-300 rounded-full mix-blend-multiply filter blur-xl animate-blob"></div>
                    <div className="absolute top-0 -right-4 w-72 h-72 bg-teal-300 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000"></div>
                    <div className="absolute -bottom-8 left-20 w-72 h-72 bg-cyan-300 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000"></div>
                </div>

                {/* Header Section */}
                <div className="relative z-10 flex items-center justify-between gap-4 mt-24 lg:mt-32 mb-8 px-4 md:px-6">
                    <div className="flex-1 min-w-0">
                        <h1
                            data-testid="gv-heading"
                            className="text-3xl md:text-5xl font-extrabold text-[#247E45] mb-2 drop-shadow-sm truncate"
                        >
                            My Videos
                        </h1>
                    </div>

                    {/* CoachName Badge - Positioned on Right */}
                    {coachName && coachNameKey > 0 && <CoachName coachName={coachName} setCoachNameKey={coachNameKey} />}
                </div>

                {/* Search & Filter Controls */}
                <div className="relative z-10 flex flex-col md:flex-row items-center gap-3 mb-8 px-6">
                    {/* Search Bar Group */}
                    <div className="flex-1 w-full md:w-auto">
                        <SearchVideos
                            setSearchText={handleSearchChange}
                            existingSearchText={searchTerm}
                            placeholderText={SEARCH_BOX.VIDEO_SEARCH.PLAYER_PERSPECTIVE.PLACEHOLDER_TEXT}
                            className="w-full"
                        />
                    </div>

                    {/* Dropdown & Count Group */}
                    <div className="flex items-center gap-3">
                        <CustomDropdown
                            options={dropdownOptions}
                            selectedValue={sortOption}
                            onChange={handleSortChange}
                            label="Filter by"
                        />

                        {/* Total Videos Badge - Compact Size with Equal Height */}
                        <div className="flex items-center gap-2 px-3 h-12 rounded-xl bg-[#247E45] text-white shadow-md hover:shadow-lg transition-all duration-300">
                            <span className="text-sm font-semibold whitespace-nowrap">Total Videos</span>
                            <span className="px-3 py-0.5 bg-white text-[#247E45] rounded-full text-sm font-bold min-w-[45px] text-center">
                                {totalRecords || 0}
                            </span>
                        </div>
                    </div>
                </div>

                {jwtToken && (
                    <>
                        {isStarted ? (
                            <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", height: "25vh" }}>
                                <CircularProgress /> <p>Loading....</p>
                            </Box>
                        ) : isError ? (
                            <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", height: "25vh" }}>
                                <p className="text-red-500 font-semibold">{error}</p>
                            </Box>
                        ) : data?.length > 0 ? (
                            <div className="relative z-10 px-6">
                                {/* Premium Video Grid */}
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
                                    {hydratedVideos.map((ele, index) => {
                                        console.log(`Video ${index}`, ele);
                                        const thumbnailUrl = videoThumbnails[ele._id] || thumbnail;
                                        const isFavAnimated = animatedFavs[ele._id];
                                        const isLoading = thumbnailLoading[ele._id];

                                        return (
                                            <div
                                                key={ele._id}
                                                data-testid={`gv-card-${index}`}
                                                className={`group relative flex flex-col rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border ${deletedPostId === ele._id ? 'opacity-0 scale-95' : ''} ${newlyUploadedVideoId === ele._id ? 'animate-pulse-slow' : 'border-slate-200'}`}
                                                style={newlyUploadedVideoId === ele._id ? {
                                                    outline: '4px solid #026b33',
                                                    outlineOffset: '1px',
                                                    boxShadow: '0 0 25px rgba(2, 107, 51, 0.6)',
                                                } : {}}
                                            >
                                                {/* Card Header with Meta Info */}
                                                <div className="flex items-start justify-between p-4 bg-gradient-to-br from-slate-50 to-white border-b border-slate-100">
                                                    <div className="flex-1 min-w-0">
                                                        <div className="flex items-center gap-2 mb-1">
                                                            <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                            </svg>
                                                            <p className="text-xs font-medium text-slate-500 truncate">
                                                                {dataFormatter(ele.updatedAt)}
                                                            </p>
                                                        </div>
                                                        <p className="text-sm font-semibold text-slate-800 truncate border-l-4 border-[#026B33] pl-2">
                                                            {truncateTitle(extractTitle(ele.game[0]?.path))}
                                                        </p>
                                                    </div>

                                                    {/* Action Icons */}
                                                    <div className="flex items-center gap-1 ml-2">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleClickFav(ele);
                                                            }}
                                                            className={`w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 transition-all duration-200 ${isFavAnimated ? 'animate-pulse scale-110' : ''}`}
                                                            title={ele.fav ? "Remove from favourites" : "Add to favourites"}
                                                        >
                                                            <i className={`fa-${ele.fav ? 'solid' : 'regular'} fa-bookmark text-[#247E45] text-[20px]`}></i>
                                                        </button>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleClickDel(ele);
                                                            }}
                                                            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-red-50 transition-all duration-200 group/delete"
                                                            title="Delete video"
                                                        >
                                                            <DeleteForeverIcon
                                                                sx={{ fontSize: 25 }}
                                                                className="text-[#247E45] group-hover/delete:text-red-600 transition-colors"
                                                            />
                                                        </button>
                                                    </div>
                                                </div>

                                                {/* Video Thumbnail */}
                                                <div
                                                    className="relative aspect-video overflow-hidden cursor-pointer group"
                                                    onClick={() => handlePlayClick(ele)}
                                                >
                                                    {/* Thumbnail Image */}
                                                    <div
                                                        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-110"
                                                        style={{ backgroundImage: `url(${thumbnailUrl})` }}
                                                    ></div>

                                                    {/* Loading Overlay */}
                                                    {isLoading && (
                                                        <div className="absolute inset-0 flex items-center justify-center bg-slate-200 bg-opacity-75 backdrop-blur-sm">
                                                            <CircularProgress size={20} />
                                                        </div>
                                                    )}

                                                    {/* Gradient Overlay */}
                                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                                    {/* Play Icon */}
                                                    <div
                                                        className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:scale-110"
                                                        data-testid="gv-play-video"
                                                    >
                                                        <div className="w-16 h-16 rounded-full bg-white/30 backdrop-blur-md flex items-center justify-center shadow-xl">
                                                            <svg className="w-8 h-8 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                                                                <path d="M8 5v14l11-7z" />
                                                            </svg>
                                                        </div>
                                                    </div>

                                                    {/* Status Button */}
                                                    <div className="absolute bottom-0 left-0 right-0">
                                                        {ele.state === "created" ? (
                                                            <Button
                                                                data-testid="gv-view-video"
                                                                onClick={() => handlePlayClick(ele)}
                                                                className="w-full rounded-none bg-gradient-to-r from-[#247E45] to-[#026B33] text-white font-medium hover:from-[#026B33] hover:to-emerald-700 transition-all duration-300"
                                                                style={{ textTransform: 'none', fontSize: '16px' }}
                                                            >
                                                                Ready to Submit
                                                            </Button>
                                                        ) : ele.state === "reviewed" ? (
                                                            <Button
                                                                data-testid="gv-view-report"
                                                                onClick={() => handlePlayClick(ele)}
                                                                className="w-full rounded-none bg-gradient-to-r from-[#247E45] to-[#026B33] text-white font-medium hover:from-[#026B33] hover:to-emerald-700 transition-all duration-300"
                                                                style={{ textTransform: 'none', fontSize: '16px' }}
                                                            >
                                                                View Report
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                data-testid="gv-request-feedback"
                                                                disabled={true}
                                                                className="w-full rounded-none"
                                                                style={{ backgroundColor: "#E0E1E6", color: "#000000", textTransform: 'none', fontSize: '16px', opacity: 0.7 }}
                                                            >
                                                                Waiting on Feedback
                                                            </Button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* No Results Message */}
                                {hydratedVideos.length === 0 && searchTerm && (
                                    <p className="text-center text-red-500 text-lg font-medium py-12">
                                        No matching videos found for this tag name
                                    </p>
                                )}

                                {/* Pagination */}
                                {totalPages > 1 && (
                                    <SearchUploadedVideoPagination
                                        totalNumberofPages={totalPages}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                    />
                                )}
                            </div>
                        ) : (
                            sortOption == "favourites" || sortOption == "created" || sortOption == "reviewRequested" || sortOption == "reviewed" ?
                                <RenderNoVideosWithSearchCondition sortOption={sortOption} /> :
                                <RenderNoVideosView />
                        )}
                    </>
                )}
                {!jwtToken && <RenderNoVideosView />}

                {/* Floating Action Button - Premium Design */}
                <div
                    className="fixed bottom-10 right-12 z-50 group cursor-pointer"
                    onClick={handleClickUploadVideo}
                >
                    <div className="relative">
                        {/* Pulsing Ring Animation */}
                        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#247E45] to-[#026B33] animate-ping opacity-75"></div>

                        {/* Main Button */}
                        <div className="relative w-16 h-16 rounded-full bg-gradient-to-br from-[#247E45] to-[#026B33] flex items-center justify-center shadow-2xl shadow-emerald-500/50 transition-all duration-300 group-hover:scale-110 group-hover:shadow-emerald-500/70 group-hover:rotate-90">
                            <i className="fa-solid fa-plus text-white text-2xl transition-transform duration-300"></i>
                        </div>
                    </div>
                </div>

                {/* Upload Video Modal */}
                <UploadVideoModel />

                {/* Delete Confirmation Dialog */}
                <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                    <DialogTitle>Confirm Deletion</DialogTitle>
                    <DialogContent>Are you sure you want to delete this video?</DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDeleteDialog(false)} color="secondary">Cancel</Button>
                        <Button onClick={confirmDelete} color="error">Delete</Button>
                    </DialogActions>
                </Dialog>

                {/* Video Playback Modal */}
                {selectedVideo && (
                    <Dialog
                        open={isModalOpen}
                        onClose={closeModal}
                        maxWidth={false}
                        fullScreen
                        sx={{
                            '& .MuiDialog-paper': {
                                margin: 0,
                                width: '100%',
                                height: '100%',
                                maxWidth: '100%',
                            },
                        }}
                    >
                        <DialogTitle style={{ display: "flex", justifyContent: "flex-end" }}>
                            <IconButton
                                edge="end"
                                color="inherit"
                                onClick={closeModal}
                                aria-label="close"
                                style={{
                                    position: 'relative',
                                    right: 0,
                                    top: 8,
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <CoachFeedback
                                videoId={selectedVideo._id}
                            />
                        </DialogContent>
                    </Dialog>
                )}
            </div>

            {/* Custom CSS for Animations */}
            <style jsx>{`
                @keyframes blob {
                    0% { transform: translate(0px, 0px) scale(1); }
                    33% { transform: translate(30px, -50px) scale(1.1); }
                    66% { transform: translate(-20px, 20px) scale(0.9); }
                    100% { transform: translate(0px, 0px) scale(1); }
                }
                .animate-blob {
                    animation: blob 7s infinite;
                }
                .animation-delay-2000 {
                    animation-delay: 2s;
                }
                .animation-delay-4000 {
                    animation-delay: 4s;
                }
            `}</style>
        </>
    );
}

export default GameVideos
